import cookies from 'js-cookie';
import { CUSTOMER_ROLE, VENDOR_ROLE } from '../constants/roles';

export const isSupplier = (type: string) => type === VENDOR_ROLE.name;

export const isCustomer = (type: string) => type === CUSTOMER_ROLE.name;

export const getAnonymousUserId = (): string => cookies.get('ajs_anonymous_id');
